export default __webpack_public_path__ + "static/media/photo.b868deda.png";